import { Component, ComponentFactoryResolver, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
// Service
import { ModalService, ModalSize, ObjectUtils } from '@cv-invision/core';
// Model
import { PublicRecordModel } from '@cv-invision/cv.invision-views.ux';
import { PTableCompGridFormattedDataModel, PTablePublicRecordDataModel } from '../model/p-table-comp-grid-data.model';
// State
import { QualityState } from '../../../state/quality.state';
// Others
import { PublicRecordModalComponent } from '../modal/public-record-modal/public-record-modal.component';

@Component({
    selector: 'cv-custom-p-table-comp-grid-cell-public-records',
    templateUrl: './custom-p-table-comp-grid-cell-public-records.component.html',
    styleUrls: ['./custom-p-table-comp-grid-cell-public-records.component.scss']
})
export class CustomPTableCompGridCellPublicRecordsComponent implements OnInit{
    @Input() orderData: Array<PTableCompGridFormattedDataModel>;
    @Input() frozenItems: Array<PTableCompGridFormattedDataModel>;
    @Input() unFrozenItems: Array<PTableCompGridFormattedDataModel>;
    @Input() columnKey: string;

	publicRecords: any;
	unfrozenData: PTablePublicRecordDataModel[] = [];
	frozenData: PTablePublicRecordDataModel[] = [];

	havePR = false;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private store: Store,
        private modalService: ModalService
    ) {

    }

    ngOnInit(): void {
		this.publicRecords = this.store.selectSnapshot(QualityState.getPublicRecords);

		const compPR = (this.publicRecords || []).filter((record: PublicRecordModel) => {
			return record.propertyIdentifier?.toUpperCase() === (this.columnKey || '').toUpperCase();
		});

		if (compPR.length) {
			this.havePR = true;
		}
    }

    /**
    * if a cell is selected, execute event.
     * @param selectedCell
     * @param index
     */
    public onSelectCell(): void {
		this.unfrozenData = this.publicRecordsFormattedData(this.unFrozenItems, this.columnKey);
        this.frozenData = this.publicRecordsFormattedData(this.frozenItems, this.columnKey);

        this.modalService
            .open({
                componentFactoryResolver: this.componentFactoryResolver,
                component: PublicRecordModalComponent,
                data: {
                    comp: this.columnKey,
                    compHeader: this.frozenData,
                    compData: this.unfrozenData,
                    publicRecords: this.publicRecords
                },
                modalConfiguration: {
                    // title: 'Public Record',
                    modalSize: ModalSize.LG
                }
            }).subscribe();
    }

    /**
     * Formatting the data to make compatible to publid records component.
     * @param dataArray
     * @param selectedColumnKey
     * @returns
     */
    public publicRecordsFormattedData(dataArray: PTableCompGridFormattedDataModel[], selectedColumnKey: string): PTablePublicRecordDataModel[] {
        const formattedDataArray: PTablePublicRecordDataModel[] = [];
        const copiedData: PTableCompGridFormattedDataModel[] = ObjectUtils.recursiveDeepCopy(dataArray)

        copiedData.forEach((data: PTableCompGridFormattedDataModel) => {
            const formattedData: PTablePublicRecordDataModel = {};
            if (data.values) {
                const item = data.values.find((value) => value.columnKey === selectedColumnKey)
                formattedData.value = item?.value;
            }
            formattedData.header = data.headerName;
            formattedData.key = data.key;
            formattedData.type = data.type;

            formattedDataArray.push(formattedData);
        });

        return formattedDataArray;
    }
}
